const handleYear = () => {
  const yearSelector = '.year';

  const yearEl = document.querySelector(yearSelector);
  const currentYear = new Date().getFullYear();

  if (yearEl !== null) {
    yearEl.textContent = currentYear;
  }
};

export default handleYear;
